import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';
import Address from 'app/models/address';

export default Base.extend({
  urlRoot: fulfillmentUrl('warehouses'),
  nestedModels: {
    address: Address,
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_warehouse.js